import CategoryTitle from '../../Basic/CategoryTitle/CategoryTitle.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import HorizontalCarousel from '../HorizontalCarousel/HorizontalCarousel.mjs';
import { StyledCarousel, StyledPadding } from '../HorizontalCarousel/HorizontalCarousel.styles.mjs';
import styled from 'styled-components';

const StyledCategoryTitle = styled(CategoryTitle) `
  margin-left: 1rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    margin-left: 0;
  }
`;
const StyledFlexContainer = styled(FlexContainer) `
  ${StyledCarousel} {
    gap: 0.5rem;
  }

  ${StyledPadding} {
    min-width: 0.5rem;
  }
`;
styled(HorizontalCarousel) `
  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0;
  }
`;
const StyledPromotionalCarouselImageContainer = styled.a `
  @media (pointer: fine) {
    :hover {
      transition-property: opacity;
      transition-duration: ${props => props.theme.animation.duration.quick1};
      transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
      opacity: 0.7;
    }
  }
`;
const StyledPromotionalCarouselImage = styled.img `
  width: 200px;
  border-radius: 0.25rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    width: 100%;
    max-width: 200px;
  }
`;

export { StyledCategoryTitle, StyledFlexContainer, StyledPromotionalCarouselImage, StyledPromotionalCarouselImageContainer };
//# sourceMappingURL=PromotionalCarousel.styles.mjs.map
